import { openDB, IDBPDatabase, DBSchema } from "idb";

interface AppDataIndexDB extends DBSchema {
  "small-avatars": {
    key: string;
    value: { key: string; value: Blob };
  };
}

export default class IndexDB {
  private static instance?: IndexDB;

  db!: Promise<IDBPDatabase<AppDataIndexDB>>;

  constructor(db: Promise<IDBPDatabase<AppDataIndexDB>>) {
    this.db = db;
  }

  public static async getInstance(): Promise<IndexDB> {
    if (!this.instance) {
      this.instance = new IndexDB(
        openDB<AppDataIndexDB>("AppData", 1, {
          upgrade(db) {
            db.createObjectStore("small-avatars");
          },
        })
      );
    }

    return this.instance;
  }

  async getAllSmallAvatarsKeys(): Promise<string[]> {
    return (await this.db).getAllKeys("small-avatars");
  }

  async getAllSmallAvatars(): Promise<AppDataIndexDB["small-avatars"]["value"][]> {
    return (await this.db).getAll("small-avatars");
  }

  async addSmallAvatar(avatarFile: Blob, key: string): Promise<void> {
    (await this.db).add("small-avatars", { value: avatarFile, key }, key);
  }

  async addSmallAvatars(avatarFiles: Blob[], keys: string[]): Promise<void> {
    const tx = (await this.db).transaction("small-avatars", "readwrite");
    const avatarsToBeAdded: Promise<string>[] = [];

    avatarFiles.forEach((avatar, i) => {
      if (avatar) {
        avatarsToBeAdded.push(tx.store.add({ value: avatar, key: keys[i] }, keys[i]));
      }
    });

    await Promise.all(avatarsToBeAdded);
  }

  async deleteSmallAvatar(key: string): Promise<void> {
    (await this.db).delete("small-avatars", key);
  }

  async deleteSmallAvatars(keys: string[]): Promise<void> {
    const tx = (await this.db).transaction("small-avatars", "readwrite");
    const avatarsToBeDeleted: Promise<void>[] = [];

    keys.forEach((key) => {
      avatarsToBeDeleted.push(tx.store.delete(key));
    });

    await Promise.all(avatarsToBeDeleted);
  }
}
